import React from "react"

import { makeStyles, useTheme } from "@material-ui/core/styles"
import { Tabs, Tab, Hidden } from "@material-ui/core"
import { Link } from "gatsby"
import { FormattedMessage, injectIntl } from "react-intl"

import { LangSelector, CartButton } from ".."
import pageNaming from "../../utilities/pageNaming"

const useStyles = makeStyles(theme => ({
  /* Styles applied to the root element. */
  root: {
    position: "relative",
    paddingLeft: theme.spacing(8),
    height: theme.spacing(14),
    backgroundColor: "white",
    display: "flex",
    justifyContent: "space-between",
  },
  secondNavbar: {
    position: "absolute",
    borderStyle: "solid",
    borderTopWidth: theme.spacing(0.5),
    borderWidth: 0,
    borderColor: theme.palette.green.support,
    paddingLeft: theme.spacing(8),
    height: theme.spacing(8),
    backgroundColor: "white",
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
  },
  esRoot: {
    position: "relative",

    [theme.breakpoints.up("lg")]: {
      paddingLeft: "64px",
    },
    [theme.breakpoints.down("lg")]: {
      paddingLeft: "4%",
    },

    height: theme.spacing(14),
    backgroundColor: "white",
    display: "flex",
    justifyContent: "space-between",
  },
  esSecondNavbar: {
    position: "absolute",
    borderStyle: "solid",
    borderTopWidth: theme.spacing(0.5),
    borderWidth: 0,
    borderColor: theme.palette.green.support,
    [theme.breakpoints.up("lg")]: {
      paddingLeft: "64px",
    },
    [theme.breakpoints.down("lg")]: {
      paddingLeft: "4%",
    },
    height: theme.spacing(8),
    backgroundColor: "white",
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
  },

  menuLeft: {
    position: "relative",
    backgroundColor: "white",
    padding: theme.spacing(2, 0, 2, 0),
    display: "flex",
    alignItems: "center",
    flexGrow: 3,
    minWidth: "500px",
  },
  menuRight: {
    alignItems: "center",

    position: "relative",
    backgroundColor: "white",
    padding: theme.spacing(2.2, 8, 2.5, 0),
    display: "flex",
    flexGrow: 1,
    justifyContent: "flex-end",
  },
  esMenuRight: {
    alignItems: "center",
    position: "relative",
    backgroundColor: "white",
    [theme.breakpoints.up("lg")]: {
      padding: theme.spacing(2.2, 8, 2.5, 0),
    },
    [theme.breakpoints.down("lg")]: {
      padding: "18px 4.3% 20px 0px",
    },

    display: "flex",
    flexGrow: 1,
    justifyContent: "flex-end",
  },

  tabs: {
    width: "800px",
    display: "inline",
    margin: theme.spacing(2, 0, 6.25, 8),
  },
  secondTabs: {
    display: "inline",
    margin: theme.spacing(2, 0, 5.7, 0),
    [theme.breakpoints.up("xs")]: {
      width: "73%",
    },
    maxWidth: "800px",
  },

  esTabs: {
    width: "1153px",
    display: "inline",

    margin: "16px 0px 50px 4.3%",

    fontFamily: theme.typography.button.fontFamily,
  },
  esSecondTabs: {
    display: "inline",
    margin: theme.spacing(2, 0, 5.7, 0),
    fontFamily: theme.typography.button.fontFamily,
    [theme.breakpoints.up("xs")]: {
      width: "80%",
    },
    maxWidth: "1200px",
  },

  tab: {
    marginRight: "9%",
    minWidth: theme.spacing(6),
    minHeight: theme.spacing(6),
    display: "block",
    padding: "37.5px 0px 0px 0px",
    letterSpacing: "1px",
    fontSize: theme.spacing(1.625),
    fontWeight: 400,
    fontFamily: theme.typography.button.fontFamily,

    whiteSpace: "nowrap",
    color: theme.palette.black.main,
    opacity: "1",

    "&:hover": {
      color: theme.palette.green.main,
    },
    "&:focus": {
      color: theme.palette.green.main,
    },
  },

  esTab: {
    marginRight: "6.2%",
    padding: "37.5px 0px 0px 0px",
    [theme.breakpoints.between("md", "lg")]: {
      marginRight: "3%",
    },

    minWidth: theme.spacing(6),
    minHeight: theme.spacing(6),
    display: "block",

    whiteSpace: "nowrap",
    opacity: "1",

    "&:hover": {
      color: theme.palette.green.main,
    },
    "&:focus": {
      color: theme.palette.green.main,
    },
  },

  lastTab: {
    minWidth: theme.spacing(6),
    minHeight: theme.spacing(6),
    display: "block",
    padding: "37.5px 0px 0px 0px",
    whiteSpace: "nowrap",
    color: theme.palette.black.main,
    opacity: "1",

    "&:hover": {
      color: theme.palette.green.main,
    },
    "&:focus": {
      color: theme.palette.green.main,
    },
  },
  tabIndicator: {
    backgroundColor: theme.palette.green.main,
    width: theme.spacing(0.25),
    display: "inline",
    height: "1px",
  },
  link: {
    textDecoration: "none",
    color: "black",
    [theme.breakpoints.up("xs")]: {
      marginRight: "9%",
    },
  },
  newsLetter: {
    textDecoration: "none",
    padding: theme.spacing(1, 1, 1, 1),
    color: theme.palette.black.main,
    marginRight: theme.spacing(3),

    "&:hover": {
      color: theme.palette.green.main,
    },
    "&:focus": {
      color: theme.palette.green.main,
    },
  },

  logoImage: {
    width: theme.spacing(7.5),
    marginBottom: theme.spacing(0.5),
    display: "inline-block",
  },
  langSelector: {
    padding: "1px",
  },
  cartButton: {
    position: "absolute",
  },
  menuBorder: {
    borderBottom: `1px solid ${theme.palette.gray.main}`,
  },
}))

export default injectIntl(props => {
  const classes = useStyles()
  const theme = useTheme()
  const Logo = props.data.mainLogo.file.url
  const localeConsts = require("../../constants/localeConsts")
  const tabStyle = (index, lastTab, esTab, tab, locale, length) => {
    if (index === length - 1) {
      return lastTab
    } else if (locale === localeConsts.es) {
      return esTab
    } else return tab
  }

  const tabsStyle = (
    mainMenu,
    esTabs,
    tabs,
    esSecondTabs,
    secondTabs,
    locale
  ) => {
    if (mainMenu && locale === localeConsts.es) {
      return esTabs
    } else if (mainMenu && locale !== localeConsts.es) {
      return tabs
    } else if (!mainMenu && locale === localeConsts.es) {
      return esSecondTabs
    } else if (!mainMenu && locale !== localeConsts.es) {
      return secondTabs
    } else return null
  }

  const rootStyle = (root, esRoot, secondNavbar, esSecondNavbar) => {
    if (props.mainMenu && props.intl.locale === localeConsts.es) {
      return esRoot
    } else if (props.mainMenu && props.intl.locale !== localeConsts.es) {
      return root
    } else if (!props.mainMenu && props.intl.locale === localeConsts.es) {
      return esSecondNavbar
    } else {
      return secondNavbar
    }
  }

  return (
    <div className={classes.menuBorder}>
      <div
        className={rootStyle(
          classes.root,
          classes.esRoot,
          classes.secondNavbar,
          classes.esSecondNavbar
        )}
      >
        <div className={classes.menuLeft}>
          {props.mainMenu && (
            <Link to={`/${props.intl.locale}`}>
              <div>
                <img
                  src={Logo}
                  className={classes.logoImage}
                  data-cy="header-logo"
                  alt="Logo"
                />
              </div>
            </Link>
          )}
          <Tabs
            classes={{ indicator: classes.tabIndicator }}
            className={tabsStyle(
              props.mainMenu,
              classes.esTabs,
              classes.tabs,
              classes.esSecondTabs,
              classes.secondTabs,
              props.intl.locale
            )}
            onChange={props.onChange}
            value={props.values || props.values === 0 ? props.values : false}
          >
            {props.mainMenu
              ? props.items.map((item, index) =>
                  item === "store locator" ||
                  item === "localizador de tiendas" ? (
                    <Tab
                      key={index}
                      className={tabStyle(
                        index,
                        classes.lastTab,
                        classes.esTab,
                        classes.tab,
                        props.intl.locale,
                        props.items.length
                      )}
                      label={item}
                      component={Link}
                      to={`/${props.locale}/store-locator`}
                    ></Tab>
                  ) : (
                    <Tab
                      key={index}
                      className={tabStyle(
                        index,
                        classes.lastTab,
                        classes.esTab,
                        classes.tab,
                        props.intl.locale,
                        props.items.length
                      )}
                      label={item}
                    ></Tab>
                  )
                )
              : props.items.map((item, index) =>
                  props.category === "our products" ||
                  props.category === "nuestros productos" ? (
                    <Tab
                      key={`${item[0]}`}
                      className={tabStyle(
                        index,
                        classes.lastTab,
                        classes.esTab,
                        classes.tab,
                        props.intl.locale,
                        props.items.length
                      )}
                      label={item[0]}
                      component={Link}
                      to={`/${props.intl.locale}/line/${pageNaming(item[1])}-${
                        props.intl.locale === localeConsts.es ? "es" : "en"
                      }`}
                    ></Tab>
                  ) : (
                    <Tab
                      key={`${item[0]}`}
                      className={tabStyle(
                        index,
                        classes.lastTab,
                        classes.esTab,
                        classes.tab,
                        props.intl.locale,
                        props.items.length
                      )}
                      label={item[0]}
                      component={Link}
                      to={`/${props.intl.locale}/${pageNaming(item[1])}`}
                    ></Tab>
                  )
                )}
          </Tabs>
        </div>
        {props.mainMenu && (
          <div
            className={
              props.intl.locale === localeConsts.es
                ? classes.esMenuRight
                : classes.menuRight
            }
          >
            <Hidden lgUp>
              <Link className={classes.newsLetter} to="/">
                <FormattedMessage id="newsletter" />
              </Link>
            </Hidden>
            {/*<LangSelector
              slug={props.slug}
              response={props.response}
              locale={props.intl.locale}
              className={classes.langSelector}
              fontSize={theme.spacing(1.625)}
            />*/}
            {props.intl.locale === localeConsts.es && <div>
              <CartButton
                className={classes.cartButton}
                onClick={props.cartToggle}
                cartLogo={props.data.shoppingCartLogo.file.url}
              />
            </div>
            }
          </div>
        )}
      </div>
    </div>
  )
})
